import React , { useContext, useEffect } from "react";
import { useNavigate , useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux'; 
import AppContext from '../../shared/components/AppContext';
import SocialButton2 from "./SocialButton2";
import SocialButton3 from "./SocialButton3";
import jwt_decode from 'jwt-decode';  
import { onChangeLoading , onChangeModalSubscription } from "../../redux/actions/ActionApp";
import {LoginService} from '../services/LoginService';
import { useTranslation } from 'react-i18next';
import "./../../pages/Login/Login.scss";
import { gapi } from 'gapi-script';
const dispatchModal = (userActiveResponse , dispatch ) => {
  if (userActiveResponse && (userActiveResponse.subscription_type === "Trial" || userActiveResponse.subscription_type === "None") ) {
      dispatch(onChangeModalSubscription());  
  } 
}

// SingIn component
// Shows all sign-in options
// Submit user info and handles the responses
// Used for Client and Respondent sing-in actions
export default function SignIn() {

    
  const myContext = useContext(AppContext); 
  const navigate = useNavigate();
  const location = useLocation();
  const loginService = LoginService(myContext);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const urlAllown = [
    '',
  ]
  const appIdFacebook = process.env.REACT_APP_SOCIAL_MEDIA_APP_ID_FACEBOOK;
  const appIdGoogle = process.env.REACT_APP_SOCIAL_MEDIA_APP_ID_GOOGLE;
  const stepAuth = (user, isNewUser = false) => {
    if (isNewUser) {
      navigate('/Register', { state : user });
    }else {
      loginPage(user , isNewUser);
    }  
  }

  const loginPage = (user , isNewUser) => {
    dispatch(onChangeLoading());
    onLoginPage(user , isNewUser, 0).then()
        .catch(() => onLoginPage(user , isNewUser, 1).then()
            .catch(() => onLoginPage(user , isNewUser, 2).then()
                .catch(error => {
                  if (error.data) {
                    myContext.notify6('alert' , 'Error' , error.data);
                  }else{
                    myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.DESCRIPTION_USER_NO_REGISTER'));
                  }
                  // navigate('/Register', { state : user });
                }))).finally(() => dispatch(onChangeLoading()));
  }

  const onLoginPage = async (user , isNewUser, role) => {
    await loginService.Token(user.profile.email , role , user).then(response => {
      localStorage.setItem('dataSocialMedia', JSON.stringify(user));
      myContext.setApplyApiKey(response.data.credential).then(() => {
        if (urlAllown.includes(location.pathname.split('/')[1]) && role === 1) {
          const userActiveResponse = jwt_decode(response.data.credential);
          dispatchModal(userActiveResponse , dispatch);
        }

        const targetPath = (() => {
          if (isNewUser) {
            return '/Register';
          }

          if (role === 0 && (location.pathname.includes('/surveys/private') || location.pathname.includes('/Profile'))) {
            return location.pathname;
          }

          return '/Survey';
        })();
        navigate(targetPath, isNewUser ? { state : user } : { replace: true } );
      });
    });

  }
  const handleSocialLogin = (user) => {
    if(user){
      stepAuth(user, false)
    }
  };

  const handleSocialLoginRegister = (user) => {
    if(user){ 
      stepAuth(user, true)
    }
  };

  const handleSocialLoginFailure = (err) => {
    console.log(err)
    myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.AUTHENTICATION_FAILED'));
  };
  
  const setNodeRef = (provider) => {
    if (myContext.ApiKeyName === "") {  
      // console.log(myContext.ApiKeyName); 
    }
  }

  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: appIdGoogle,
        scope: "email",
        plugin_name:'App Name that you used in google developer console API'
      });
    };
    gapi.load('client:auth2', initClient);
  });

    return ( 
        <div className="SignIn">
            <h2>{t('SIGNIN.TITLE')}</h2>
            <div>
              <SocialButton2
                provider="facebook"
                appId={appIdFacebook}
                  onLoginSuccess={handleSocialLogin}
                  onLoginFailure={handleSocialLoginFailure}
                  getInstance={setNodeRef}
                  key={'facebook'}
                  >
                {t('SIGNIN.SOCIAL_BUTTON_FB')}
              </SocialButton2>
              <SocialButton3
                provider="google"
                appId={appIdGoogle}
                  onLoginSuccess={handleSocialLogin}
                  onLoginFailure={handleSocialLoginFailure}
                  key={'google'}
                  >
                {t('SIGNIN.SOCIAL_BUTTON_GOOGLE')}
              </SocialButton3> 
              <div>
                <span></span>
                <h4>{t('SIGNIN.LABEL_OR')}</h4>
                <span></span>
              </div>
              <h2>{t('SIGNIN.TITLE_REGISTER')}</h2>
              <div style={{"margin":"0", "flex-direction": "column"}} >
              <SocialButton2
                  provider="facebook"
                  appId={appIdFacebook}
                    onLoginSuccess={handleSocialLoginRegister}
                    onLoginFailure={handleSocialLoginFailure}
                    key={'facebookSmall'}
                    >
                {t('SIGNIN.SOCIAL_REGISTER_BUTTON_FB')}
                </SocialButton2> 
                <SocialButton3 style={{"margin":"0"}}
                    provider='google'
                    appId={appIdGoogle}
                    onLoginSuccess={handleSocialLoginRegister}
                    onLoginFailure={handleSocialLoginFailure}
                    key={'googleSmall'}
                    >
                  {t('SIGNIN.SOCIAL_REGISTER_BUTTON_GOOGLE')}
                </SocialButton3>
              </div> 
            </div>
        </div>
    );
}
